module.exports = __webpack_public_path__ + "static/media/Bijay_Kumar.62c46281.png";